<template>
  <div>
    <div class="environment__switch">
      <span
        class="environment__switch-label is-size-7"
        :class="{'environment__switch-label--success has-text-weight-bold': !isTest}">
          Live
      </span>
      <sc-env-switch
        v-model="isTest"
        :color="isTest ? 'red' : 'green'" />
      <span
        class="environment__switch-label is-size-7"
        :class="{'environment__switch-label--danger has-text-weight-bold': isTest}">
          Test
      </span>
    </div>
  </div>
</template>

<script>
  import { ScEnvSwitch } from '@intelipost-js/secure-components';
  import { Auth, Storage, GraphQlClient } from '@intelipost-js/secure-providers';

  export default {
    name: 'sc-environment',
    data() {
      return {
        isTest: Auth.getUser() && !Auth.getUser().is_production,
      };
    },
    beforeCreate() {
      const { is_production } = Auth.getUser();

      if (GraphQlClient && GraphQlClient.setProductionEnv) {
        // Set is_production env variable on graphql client
        GraphQlClient
          .setProductionEnv(is_production);
      }
    },
    watch: {
      isTest(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (heap) {
            heap.addUserProperties({ 'Is Production': !newValue });
          }

          const isMigrated = Storage.get('userMigrated', 'local');

          GraphQlClient
            .setProductionEnv(!newValue);

          Auth.updateUser({ is_production: !newValue });
          Auth.setMenu().then(() => window.location.reload());

          if (!isMigrated) {
            this.$store.dispatch('permissions/getEnvStatus');
          }
        }
      },
    },
    components: {
      ScEnvSwitch,
    },
  };
</script>

<style lang="scss">
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

  .environment {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: .3rem;
    transition: background-color 500ms linear;
    z-index: 9;
  }
  .environment--success{
    background-color: $primary;
  }
  .environment--danger{
    background-color: #e84c3d;
  }
  .environment__switch{
    display: flex;
    align-items: center;
  }
  .environment__switch-label{
    padding: 0 .5rem;
  }

  .environment__switch-label--success{
    color: darken($primary, 15);
  }

  .environment__switch-label--danger{
    color: #e84c3d;
  }

  .environment__switch{
    .vue-switcher-theme--default.vue-switcher-color--green.vue-switcher--unchecked{
      div{
        background-color: $primary;
        &:after{
          background-color: #f5f5f5;
          border: 1px solid #ccc;
        }
      }
    }
    .vue-switcher-theme--default.vue-switcher-color--red{
      div{
        background-color: #e84c3d;

        &:after{
          background-color: #f5f5f5;
          border: 1px solid #ccc;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/sc-environment/ScEnvironment.vue